<template>
  <v-card color="#f2f2f2">
    <!-- <v-toolbar color="#f2f2f2"> -->
      <div
        class="d-flex justify-space-between pt-3 --info-header"
        style="width: 100%; background: #fff"
      >
      <!-- <div> -->

        <!-- <v-toolbar-title> -->
          <div class="d-flex">
            <!-- <div v-html="formatMediaType" v-if="$root.isMobile" class="d-flex justify-center" style="flex: 0 0 100%"></div> -->
            <v-img
              :src="item.logo"
              v-if="item.logo"
              max-width="40"
              max-height="40"
              cover
              class="ml-2"
            ></v-img>
            <span class="--info-title-line" :class="{'ml-3': item.logo}"
              ><strong>{{ item.display_name }}</strong> - {{ info.title }}
            </span>
          </div>
          
        <!-- </v-toolbar-title> -->
      <!-- </div> -->
       
      <!-- </div> -->

        <v-tabs
          align-with-title
          class="mt-n2"
          v-model="tab"
        >
          <!-- <v-tabs-slider color="white"></v-tabs-slider> -->
          <v-tab>Informações</v-tab>
          <v-tab>Perfil do público</v-tab>
          <v-tab>Localidades e cobertura</v-tab>
          <v-tab>Regras de compra</v-tab>
          <v-tab>Produção</v-tab>
        </v-tabs>
        </div>
    <!-- </v-toolbar> -->
    <div
            class="d-flex align-center my-4 --info-title-subline"
            style="font-size: 15px"
          >
            <div class="mr-3">
              <v-img
                :src="mediaType"
                height="24"
                width="24"
                contain
                class="mx-3"
              ></v-img>
            </div>
            <div class="mr-3" v-if="info.bucket" v-html="info.bucket"></div>
            <div class="mr-3" v-if="info.timeslot" v-html="info.timeslot"></div>
            <div class="mr-3" v-if="info.location" v-html="info.location"></div>
          </div>
    <v-tabs-items v-model="tab">
      <v-tab-item><about-tab :item="item"></about-tab></v-tab-item>
      <v-tab-item><target-tab :snap="item"></target-tab></v-tab-item>
      <v-tab-item><markers-tab :item="item"></markers-tab></v-tab-item>
      <v-tab-item><rules-tab :item="item"></rules-tab></v-tab-item>
      <v-tab-item><specifications-tab :item="item"></specifications-tab></v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import AboutTab from "@/components/InfoBoards/AboutTab.vue";
import TargetTab from "@/components/InfoBoards/TargetTab.vue";
import MarkersTab from "@/components/InfoBoards/MapTab.vue";
import RulesTab from "@/components/InfoBoards/RulesTab.vue";
import SpecificationsTab from "@/components/InfoBoards/SpecificationsTab.vue";
import jsFunctions from "@/plugins/helper";

export default {
  name: "AsuInfo",
  components: { AboutTab, TargetTab, MarkersTab, RulesTab, SpecificationsTab },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    styles() {
      return this.$root.isMobile
        ? "height: 40px; "
        : "height: 90px; margin-top: -10px";
    },
    mediaType() {
      let mediaType = jsFunctions.mediaTypeLogo(
        this.item.asus.media_type[0].parents[0]
      );
      return `https://lion-web-site.s3.amazonaws.com/logos/email/ico-${mediaType}.svg`;
    },
    formatMediaType(){
      return jsFunctions.formatMediaType(this.item.asus.media_type[0].parents[0], 18, 18)
    }
  },
  props: {
    item: Object,
    info: Object,
  },
};
</script>
<style lang="scss">
.--info {
  .card {
    position: relative;
  }
  .v-list {
    padding: 0;
  }
  .v-list-item {
    padding: 0;
  }
  .v-list-item__content {
    padding: 0;
  }
  h3 {
    color: #707070;
  }
  .--label {
    position: absolute;
    bottom: 10px;
    left: 10px;
    padding: 3px;
    background: #fff;
    color: #909090;
    font-weight: bold;
    font-size: 12px;
  }
  .v-toolbar--extended {
    height: auto !important;
  }
  .v-toolbar__content {
    min-height: 64px;
    height: auto !important;
  }
  .theme--light.v-tabs-items {
    background: #f2f2f2;
  }
  @media screen and (max-width: 480px) {
    .v-slide-group__next,
    .v-slide-group__prev {
      flex: 0 1 20px;
      min-width: 20px;
    }
    .v-toolbar__extension {
      height: auto !important;
    }
    .v-tabs--vertical {
      height: auto !important;
      .v-slide-group__wrapper {
        height: auto;
      }
      .v-tab {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }
    .--info-header {
      flex-flow: column;
    }
    .--info-title {
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
    .--info-title-line {
      flex-flow: column;
      flex-wrap: wrap;
      justify-content: center;
      strong {
        display: flex;
        justify-content: center;
      }
    }
    .--info-title-subline {
      font-size: 15px;
      flex-flow: column;
    }
    .--close {
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
}
</style>